import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';
import RecurringForm from 'components/form/RecurringForm/container';

export default styled(RecurringForm)`
  background-color: #f2f5f8;
  padding: 20px;
  margin-bottom: 20px;
  outline: 1px solid var(--grey300);
  border-radius: 4px;

  ${media.lessThan('small')`
    padding: ${gridSizes('S')};
    padding-top: ${gridSizes('M')};
  `}

  .title {
    font-size: 32px;
    line-height: normal;
    margin: 0;
    padding: 0;
    font-weight: ${weights('medium')};

    ${media.lessThan('small')`
      font-size: ${gridSizes('L')};
    `}
  }
`;
